import { useIntl } from 'react-intl';

export const useQuotes = () => {
  const intl = useIntl();

  return [
    {
      text: intl.formatMessage({
        id: 'LoadingContent.quote1Text',
        defaultMessage:
          'The universe never did make sense; I suspect it was built on government contract.',
        description: 'Quote about the universe and government contract',
      }),
      cite: 'Robert A. Heinlein',
    },
    {
      text: intl.formatMessage({
        id: 'LoadingContent.quote2Text',
        defaultMessage:
          "Always read your contract. Know what you're getting yourself into. Know your worth.",
        description: 'Quote about reading contracts and knowing your worth',
      }),
      cite: 'Lil Durk',
    },
    {
      text: intl.formatMessage({
        id: 'LoadingContent.quote3Text',
        defaultMessage:
          'I wish to be cremated. One tenth of my ashes shall be given to my agent, as written in our contract.',
        description: 'Quote about cremation and contract',
      }),
      cite: 'Groucho Marx',
    },
    {
      text: intl.formatMessage({
        id: 'LoadingContent.quote4Text',
        defaultMessage:
          'Early on, they were timing my contract with an egg timer.',
        description: 'Quote about timing contract with an egg timer',
      }),
      cite: "Conan O'Brien",
    },
    {
      text: intl.formatMessage({
        id: 'LoadingContent.quote5Text',
        defaultMessage:
          "A verbal contract isn't worth the paper it's written on.",
        description: 'Quote about verbal contracts',
      }),
      cite: 'Samuel Goldwyn',
    },
    {
      text: intl.formatMessage({
        id: 'LoadingContent.quote6Text',
        defaultMessage:
          'The first principle of a civilized state is that the power is legitimate only when it is under contract.',
        description: 'Quote about power and contract in a civilized state',
      }),
      cite: 'Walter Lippmann',
    },
  ];
};
